export class Client {
    public id:string;
    public customField1: string;
    
    constructor() {
        this.id = "";
        this.customField1 = "";
    }

    getDisplayId() {
        if (this.customField1) {
            return this.customField1;
        }
        else {
            return this.id;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/client.ts